import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../utils/api';

const initialState = {
  messages: [],
  status: 'idle',
  error: null,
  templates: [],
};

export const fetchHistory = createAsyncThunk('chat/fetchHistory', async ({ token }, { rejectWithValue }) => {
  try {
    const res = await api.getHistory(10, 0, token);
    if (!res.success) return rejectWithValue(res.error);
    return res.data;
  } catch (error) {
    return rejectWithValue('Sohbet geçmişi yüklenemedi.');
  }
});

export const sendMessage = createAsyncThunk('chat/sendMessage', async ({ message, context, token, wordDocument }, { rejectWithValue }) => {
  try {
    const res = await api.editWithFormData(message, context, token, wordDocument)
    if (!res.success) return rejectWithValue(res.error);
    return res.data;
  } catch (error) {
    return rejectWithValue('Mesaj gönderilemedi.');
  }
});

export const fetchTemplates = createAsyncThunk('chat/fetchTemplates', async ({ token }, { rejectWithValue }) => {
  try {
    const res = await api.getTemplates(token);
    if (!res.success) return rejectWithValue(res.error);
    return res.data;
  } catch (error) {
    return rejectWithValue('Şablonlar yüklenemedi.');
  }
});

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setMessages(state, action) {
      state.messages = action.payload;
      state.error = null;
    },
    addMessage(state, action) {
      const message = {
        ...action.payload,
        id: Date.now() + Math.random(), // Simple unique ID
        timestamp: action.payload.timestamp || new Date().toLocaleTimeString('tr-TR', { 
          hour: '2-digit', 
          minute: '2-digit' 
        })
      };
      state.messages.push(message);
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.status = 'failed';
    },
    clearChat(state) {
      state.messages = [];
      state.status = 'idle';
      state.error = null;
    },
    clearError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchHistory.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchHistory.fulfilled, (state, action) => {
        state.status = 'succeeded';
        // Add timestamps to messages if they don't have them
        state.messages = action.payload.map((msg, index) => ({
          ...msg,
          id: msg.id || Date.now() + index,
          timestamp: msg.timestamp || new Date(Date.now() - (action.payload.length - index) * 60000).toLocaleTimeString('tr-TR', { 
            hour: '2-digit', 
            minute: '2-digit' 
          })
        }));
        state.error = null;
      })
      .addCase(fetchHistory.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Sohbet geçmişi yüklenemedi.';
      })
      .addCase(sendMessage.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(sendMessage.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const aiMessage = {
          role: 'katip',
          message: action.payload?.chatMessage || 'Yanıt alındı.',
          timestamp: new Date().toLocaleTimeString('tr-TR', { 
            hour: '2-digit', 
            minute: '2-digit' 
          }),
          id: Date.now() + Math.random(),
          action: action.payload.data?.action || 'INSERT_AFTER'
        };
        state.messages.push(aiMessage);
        state.error = null;
      })
      .addCase(sendMessage.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Mesaj gönderilemedi.';
      })
      .addCase(fetchTemplates.fulfilled, (state, action) => {
        state.templates = action.payload;
      });
  },
});

export const { setMessages, addMessage, setStatus, setError, clearChat, clearError } = chatSlice.actions;
export default chatSlice.reducer; 